import { render } from "./contact-modal.vue?vue&type=template&id=cc5ef654"
import script from "./contact-modal.vue?vue&type=script&lang=js"
export * from "./contact-modal.vue?vue&type=script&lang=js"

import "./contact-modal.vue?vue&type=style&index=0&id=cc5ef654&lang=scss"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__